// © Microsoft Corporation. All rights reserved.

import Navbar from "../../common/navbar/Navbar";
import ProfileCard from "../profile-card/ProfileCard";
import ProfileTabs from "../profile-tabs/ProfileTabs";
import React from "react";
import { SocialProps } from "../../Social.props";
import { classNames } from "@microsoft/fast-web-utilities";
import { initializeSubscriptionSdk } from "@msnews/subscription-sdk-wrapper";
import { enums } from "../../utils/enums";
import { getContextData } from "@msnews/core";
import { hasThemeBase } from "../../utils/themeHelpers";

export interface ProfilePageState {
    subscriptionSdkInitialized: boolean;
}

export default class ProfilePage extends React.Component<SocialProps, ProfilePageState> {

    constructor(props: SocialProps) {
        super(props);
        this.state = {
            subscriptionSdkInitialized: false
        };
    }

    componentDidMount() {
        this.props.profileConnector && this.props.profileConnector.onProfilePageComponentConnected(this.props.id);
    }

    componentDidUpdate(prevProps) {
        if (this.props.id != null && this.props.market != null && prevProps.id != this.props.id || prevProps.market != this.props.market) {
            this.props.profileConnector && this.props.profileConnector.onProfilePageComponentConnected(this.props.id);
        }

        // Mark the TTVR when the store is updated after the social api for user profile returned
        if (!prevProps.users && this.props.users) {
            this.props.markTtvr();
        }

        const { me, id, enableSubscriptionFeatures } = this.props;
        const isSelf = me && (me.id === id || id == "me");
        if (isSelf && enableSubscriptionFeatures && !this.state.subscriptionSdkInitialized) {
            initializeSubscriptionSdk();
            this.setState(() => ({ subscriptionSdkInitialized: true }));
        }
    }

    render() {
        const t = this.props.t;
        let emptyState = null;
        let props = { ...this.props, t, id: this.props.me && this.props.id == "me" ? this.props.me.id : this.props.id};

        const { me, id } = this.props;
        const isSelf = me && (me.id == id || id == "me");
        const isSuperApp = hasThemeBase(this.props.theme, enums.theme.superappBase);

        if (this.props.users && this.props.users[props.id] && this.props.users[props.id].isFetched && this.props.users[props.id].data && !this.props.users[props.id].data.isSocialUser) {
            if (!this.props.me || this.props.me.state == enums.userStateType.anonymous) {
                // This profile does not exist
                emptyState = enums.profilePageEmptyStates.NoUser;
            } else if (this.props.me.state == enums.userStateType.existingUser) {
                // Redirect to my profile
                const requestContext = this.props.requestContext;
                const locationHref = getContextData(requestContext.data.locationHref, "locationHref");
                if (locationHref.includes(`id=${this.props.id}`)) {
                    window.location.href = locationHref.replace(`id=${this.props.id}`, `id=${this.props.me.id}`);
                } else {
                    props = { ...props, id: this.props.me.id };
                }
            } else {
                // Show Join Now design here since user is not a social user yet
                emptyState = enums.profilePageEmptyStates.NotSocialUser;
            }
        }

        return (
            <div className={classNames(
                this.props.managedClasses.profilePageContainer,
                this.props.responsiveClass,
                [this.props.managedClasses.profilePageSuperAppContainer, isSuperApp]
            )}>
                { isSuperApp &&
                    <Navbar
                        {...{...props }}
                        onEllipsisClick={!isSelf && (() => this.navbarEllipsisHandler())}
                        onBackClick={() => this.navbarBackHandler()}
                        whiteIcons={true}
                    />
                }
                <ProfileCard {...{...props, emptyState }} />
                <ProfileTabs {...{...props, emptyState }} />
            </div>
        );
    }

    /**
     * SuperApp Function
     */
    navbarEllipsisHandler() {
        this.showReportMenu();
    }

    navbarBackHandler() {
        if (history.state.initial) {
            this.props.popupConnector.closePopup();
        } else {
            history.back();
        }
    }

    /* REPORTING */
    showReportMenu() {
        const { popupConnector, id } = this.props;
        popupConnector.openPopup("profilereportmenu", { id: id });
    }
}
